var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37492 0.125H0.62492C0.550764 0.125016 0.478277 0.147018 0.416623 0.188224C0.354969 0.229431 0.306917 0.287992 0.278541 0.356505C0.250165 0.425017 0.242738 0.500405 0.257201 0.573137C0.271664 0.645869 0.307367 0.712681 0.359795 0.765125L3.7348 4.14013C3.7696 4.17496 3.81093 4.20259 3.85643 4.22144C3.90192 4.24029 3.95068 4.25 3.99992 4.25C4.04916 4.25 4.09792 4.24029 4.14342 4.22144C4.18891 4.20259 4.23024 4.17496 4.26505 4.14013L7.64005 0.765125C7.69247 0.712681 7.72818 0.645869 7.74264 0.573137C7.7571 0.500405 7.74968 0.425017 7.7213 0.356505C7.69292 0.287992 7.64487 0.229431 7.58322 0.188224C7.52156 0.147018 7.44908 0.125016 7.37492 0.125Z",
    fill: "#67737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort_down.b4c4760d3e620104233f7094d5f80dc1.svg";
export { ForwardRef as ReactComponent };